import { Fragment, type ReactNode } from 'react'

import { ConversationRichTextLinkStyled } from './styles/ConversationRichTextLinkStyled'
import { ConversationRichTextStrongStyled } from './styles/ConversationRichTextStrongStyled'
import {
  type MessageToken,
  tokenizeMessageContent,
} from './tokenizeMessageContent'

export interface IConversationRichTextProps {
  content: string
}

const renderToken = (token: MessageToken, key: string): ReactNode => {
  switch (token.type) {
    case 'strong':
      return (
        <ConversationRichTextStrongStyled key={key}>
          {token.value}
        </ConversationRichTextStrongStyled>
      )
    case 'link':
      return (
        <ConversationRichTextLinkStyled key={key} to={token.href}>
          {token.value}
        </ConversationRichTextLinkStyled>
      )
    default:
      return <Fragment key={key}>{token.value}</Fragment>
  }
}

export const ConversationRichText = ({
  content,
}: IConversationRichTextProps) => {
  let offset = 0

  return (
    <>
      {tokenizeMessageContent(content).map((token) => {
        const key = `${token.type}-${offset}`
        offset += token.value.length

        return renderToken(token, key)
      })}
    </>
  )
}
